export class ActivityModel {
  constructor ({
    id,
    name,
    startDate,
    endDate,
    place,
    country,
    url,
    disciplineIds,
    activityType,
    number,
    selection,
    description,
    sourceType,
    meta,
  }) {
    this.id = id
    this.name = name
    this.startDate = startDate || null
    this.endDate = endDate || null
    this.place = place || null
    this.country = country || null
    this.url = url || null
    this.disciplineIds = disciplineIds || []
    this.activityType = activityType || null
    this.number = number || null
    this.selection = selection || null
    this.description = description || null
    this.sourceType = sourceType || null
    this.meta = meta || {}
    this.meta.custom_files = meta.custom_files || []
  }
}



// WEBPACK FOOTER //
// ./src/server/modules/activities/ActivityModel.js